import React from 'react';
import PropTypes from 'prop-types';
import { prettyNumber } from '../../../../lib/utils';
import ghAnalytics from '../../../../lib/analytics';
import LayerListItem from '../LayerListItem';
import Slider from '../../../Form/Slider';
import styles from './LayerCategoryDetail.module.scss';

function LayerCategoryDetail(props) {
  const { category: { categoryName, layers = [], opacity, subCategories = [] }, dispatch, stateName, } = props
  const opacityChanged = (value, _) => {
    const opacity = value / 100
    ghAnalytics.logLayerOpacityChanged(
      opacity,
      stateName,
      categoryName
    );

    dispatch({
      type: 'layers/setLayerCategoryOpacity',
      payload: {
        stateName,
        categoryName,
        opacity,
      },
    });
  };
  const isCategoryEnabled = Boolean(subCategories.find(sc => sc.layers.find(l => l.control.enabled)))

  return (
    <>
      <div className={styles.opacityBox}>
        <div className={styles.opacityRow}>
          <Slider
            min={0}
            max={100}
            step={1}
            disabled={!isCategoryEnabled}
            value={[opacity * 100]}
            showLabel={true}
            labelFormatter={(thumbProps, state) => `${prettyNumber(state.valueNow, 0)} %`}
            onAfterChange={opacityChanged}
          />
        </div>
        <div className={styles.opacityInfo}>Transparency</div>
      </div>
      <div className={styles.stateLayerList}>
        <div className={styles.categoryLayers}>
          {layers.map((layerObj, i) => {
            return (
              <LayerListItem
                key={i}
                stateName={stateName}
                categoryName={categoryName}
                layer={layerObj}
                {...props}
              />
            );
          })}
        </div>
        {subCategories.map((subCategory, i) => {
          return (
            <div key={`subcat-${i}`} className={styles.subCategorySection}>
              <div>
                {subCategory.layers.map((layerObj, i) => {
                  const { subCategoryName } = subCategory
                  return (
                    <LayerListItem
                      key={i}
                      stateName={stateName}
                      categoryName={categoryName}
                      subCategoryName={subCategoryName}
                      layer={layerObj}
                      {...props}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

LayerCategoryDetail.propTypes = {
  category: PropTypes.object,
  categoryName: PropTypes.string,
  stateName: PropTypes.string,
};

export default LayerCategoryDetail